//Expose PrimeVue Toast service to the global window object, to use as stacking central Toasts
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

const PrimeVuePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{orange-50}',
            100: '{orange-100}',
            200: '{orange-200}',
            300: '{orange-300}',
            400: '{orange-400}',
            500: '{orange-500}',
            600: '{orange-600}',
            700: '{orange-700}',
            800: '{orange-800}',
            900: '{orange-900}',
            950: '{orange-950}',
        }
    }
});

import ToastRoot from './components/ToastRoot.vue';

//Create and mount the Vue app
const app = createApp(ToastRoot);
app.use(PrimeVue, {
    theme: {
        preset: PrimeVuePreset,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    },
})
app.use(ToastService);
app.component('Toast', Toast);
app.mount('#toast-root');